// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* chrome, safari */
ion-content::part(scroll)::-webkit-scrollbar {
  scrollbar-width: thin;
}

/* firefox */
ion-content::part(scroll) {
  scrollbar-width: thin;
}

ion-menu ion-content ion-row {
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.356);
  margin-bottom: 5px;
  cursor: pointer;
}
ion-menu ion-content ion-row:hover {
  transform: scale(1.05);
  transition: all 0.1s ease-in-out;
}

ion-tab-button {
  --color-selected: var(--main-color);
}

.iconActive {
  fill: var(--main-color);
}

.iconOff {
  fill: #808080;
}`, "",{"version":3,"sources":["webpack://./src/app/home/home.component.scss"],"names":[],"mappings":"AAAA,mBAAA;AACA;EACE,qBAAA;AACF;;AACA,YAAA;AACA;EACE,qBAAA;AAEF;;AACA;EACE,aAAA;EACA,kBAAA;EACA,gDAAA;EACA,kBAAA;EACA,eAAA;AAEF;AAAE;EACE,sBAAA;EACA,gCAAA;AAEJ;;AAEA;EACI,mCAAA;AACJ;;AACA;EACI,uBAAA;AAEJ;;AAAA;EACI,aAAA;AAGJ","sourcesContent":["/* chrome, safari */\nion-content::part(scroll)::-webkit-scrollbar {\n  scrollbar-width: thin;\n}\n/* firefox */\nion-content::part(scroll) {\n  scrollbar-width: thin;\n}\n\nion-menu ion-content ion-row {\n  padding: 15px; \n  border-radius: 4px; \n  box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.356);\n  margin-bottom: 5px; \n  cursor: pointer;\n\n  &:hover {\n    transform: scale(1.05);\n    transition: all 0.1s ease-in-out;\n  }\n}\n\nion-tab-button {\n    --color-selected: var(--main-color);\n}\n.iconActive {\n    fill: var(--main-color);\n}\n.iconOff {\n    fill: #808080;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
